import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  effect,
  input,
  signal,
  viewChild,
} from '@angular/core';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { type BDMenuItem } from '@bizzdesign/shared/models';
import { ButtonModule } from 'primeng/button';
import { type Popover, PopoverModule } from 'primeng/popover';
import { TooltipModule } from 'primeng/tooltip';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { SearchableMenuComponent } from '../searchable-menu/searchable-menu.component';

@Component({
  selector: 'bd-filepath',
  imports: [
    BreadcrumbComponent,
    ButtonModule,
    PopoverModule,
    SharedI18nModule,
    TooltipModule,
  ],
  styleUrl: './filepath.component.scss',
  templateUrl: './filepath.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilepathComponent {
  readonly breadcrumbItems = input<BDMenuItem[]>([]);
  readonly isLastToolbarItem = input(false);
  readonly chevronVisible = input(false);
  readonly chevronDisabled = input(false);
  readonly chevronAriaLabel = input<string | undefined>(undefined);
  readonly chevronTooltip = input<string | undefined>(undefined);

  readonly popover = viewChild<Popover>('popover');
  readonly popoverOpen = signal(false);

  private readonly projectedMenu = contentChild(SearchableMenuComponent);

  constructor() {
    // Defer hide a microtask so the click event that emitted dismiss finishes
    // bubbling before overlayVisible flips — otherwise pMotion can catch a
    // rapid subsequent chevron re-open mid-leave and end up closed.
    effect((onCleanup) => {
      const menu = this.projectedMenu();
      if (!menu) return;
      const sub = menu.dismiss.subscribe(() =>
        queueMicrotask(() => this.popover()?.hide()),
      );
      onCleanup(() => sub.unsubscribe());
    });
  }
}
